import { styled } from '../../Styles/stitches.config'

export const StyledStarsWithTotal = styled('div', {
    alignItems: 'center',
    display: 'flex',
    gap: '$1',
    h: 'inherit',
})
